import gql from 'graphql-tag';

//
//// Highlights
//

export const SALES_KPI = gql`
  query salesKPI($clientID: String!, $globalFilter: GlobalFilterInput!) {
    salesKPI(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const UNITS_KPI = gql`
  query unitsKPI($clientID: String!, $globalFilter: GlobalFilterInput!) {
    unitsKPI(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const POD_KPI = gql`
  query podKPI($clientID: String!, $globalFilter: GlobalFilterInput!) {
    podKPI(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const STORES_SELLING_KPI = gql`
  query storesSellingKPI($clientID: String!, $globalFilter: GlobalFilterInput!) {
    storesSellingKPI(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const UNITS_STORES_SELLING_KPI = gql`
  query unitsStoresSellingKPI($clientID: String!, $globalFilter: GlobalFilterInput!) {
    unitsStoresSellingKPI(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const STORES_SELLING_PERC_KPI = gql`
  query storesSellingPercentageKPI($clientID: String!, $globalFilter: GlobalFilterInput!) {
    storesSellingPercentageKPI(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const OPPORTUNITY_GAP_KPI = gql`
  query opportunityGapKPI($clientID: String!, $globalFilter: GlobalFilterInput!) {
    opportunityGapKPI(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const DISTRIBUTION_KEPT_KPI = gql`
  query distributionKeptKPI($clientID: String!, $globalFilter: GlobalFilterInput!) {
    distributionKeptKPI(client: $clientID, globalFilter: $globalFilter) {
      amount
    }
  }
`;

export const DISTRIBUTION_LOST_KPI = gql`
  query distributionLostKPI($clientID: String!, $globalFilter: GlobalFilterInput!) {
    distributionLostKPI(client: $clientID, globalFilter: $globalFilter) {
      amount
    }
  }
`;

export const DISTRIBUTION_VOID_KPI = gql`
  query distributionVoidKPI($clientID: String!, $globalFilter: GlobalFilterInput!) {
    distributionVoidKPI(client: $clientID, globalFilter: $globalFilter) {
      amount
    }
  }
`;

export const DISTRIBUTION_FILLED_KPI = gql`
  query distributionFilledKPI($clientID: String!, $globalFilter: GlobalFilterInput!) {
    distributionFilledKPI(client: $clientID, globalFilter: $globalFilter) {
      amount
    }
  }
`;

export const SALES_KPI_PORTFOLIO = gql`
  query salesKPIPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    salesKPIPortfolio(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const UNITS_KPI_PORTFOLIO = gql`
  query unitsKPIPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    unitsKPIPortfolio(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const POD_KPI_PORTFOLIO = gql`
  query podKPIPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    podKPIPortfolio(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const STORES_SELLING_KPI_PORTFOLIO = gql`
  query storesSellingKPIPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    storesSellingKPIPortfolio(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const STORES_GAP_KPI_PORTFOLIO = gql`
  query storesSellingPercentageKPIPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    storesSellingPercentageKPIPortfolio(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

export const OPPORTUNITY_GAP_KPI_PORTFOLIO = gql`
  query opportunityGapKPIPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    opportunityGapKPIPortfolio(client: $clientID, globalFilter: $globalFilter) {
      amount
      amountDelta
    }
  }
`;

//
//// Overview Tables
//

export const ACCOUNT_POD_GAINS_SERIES = gql`
  query accountPodGainsSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
    accountPodGainsSeries(
      client: $clientID
      globalFilter: $globalFilter
      pageable: { page: 1, pageSize: 10, sortedBy: "amount", sortDirection: DESC }
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        label
        amount
      }
    }
  }
`;

export const ACCOUNT_POD_GAINS_SERIES_PORTFOLIO = gql`
  query accountPodGainsSeriesPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    accountPodGainsSeriesPortfolio(
      client: $clientID
      globalFilter: $globalFilter
      pageable: { page: 1, pageSize: 10, sortedBy: "amount", sortDirection: DESC }
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        label
        amount
      }
    }
  }
`;

export const ACCOUNT_POD_LOSSES_SERIES = gql`
  query accountPodLossesSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
    accountPodLossesSeries(
      client: $clientID
      globalFilter: $globalFilter
      pageable: { page: 1, pageSize: 10, sortedBy: "amount", sortDirection: ASC }
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        label
        amount
      }
    }
  }
`;

export const ACCOUNT_POD_LOSSES_SERIES_PORTFOLIO = gql`
  query accountPodLossesSeriesPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    accountPodLossesSeriesPortfolio(
      client: $clientID
      globalFilter: $globalFilter
      pageable: { page: 1, pageSize: 10, sortedBy: "amount", sortDirection: ASC }
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        label
        amount
      }
    }
  }
`;

export const ACCOUNT_POD_OPPORTUNITIES_SERIES = gql`
  query accountOpportunitiesSalesSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
    accountOpportunitiesSalesSeries(
      client: $clientID
      globalFilter: $globalFilter
      pageable: { page: 1, pageSize: 10, sortedBy: "amount", sortDirection: DESC }
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        label
        amount
      }
    }
  }
`;

export const ACCOUNT_POD_OPPORTUNITIES_SERIES_PORTFOLIO = gql`
  query accountOpportunitiesSalesSeriesPortfolio(
    $clientID: String!
    $globalFilter: PortfolioInput!
  ) {
    accountOpportunitiesSalesSeriesPortfolio(
      client: $clientID
      globalFilter: $globalFilter
      pageable: { page: 1, pageSize: 10, sortedBy: "amount", sortDirection: DESC }
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        label
        amount
      }
    }
  }
`;

export const ITEMS_POD_GAINS_SERIES = gql`
  query itemsPodGainsSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
    itemsPodGainsSeries(
      client: $clientID
      globalFilter: $globalFilter
      pageable: { page: 1, pageSize: 10, sortedBy: "amount", sortDirection: DESC }
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        label
        amount
      }
    }
  }
`;

export const ITEMS_POD_LOSSES_SERIES = gql`
  query itemsPodLossesSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
    itemsPodLossesSeries(
      client: $clientID
      globalFilter: $globalFilter
      pageable: { page: 1, pageSize: 10, sortedBy: "amount", sortDirection: ASC }
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        label
        amount
      }
    }
  }
`;

export const ITEMS_POD_OPPORTUNITIES_SERIES = gql`
  query itemsOpportunitiesSalesSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
    itemsOpportunitiesSalesSeries(
      client: $clientID
      globalFilter: $globalFilter
      pageable: { page: 1, pageSize: 10, sortedBy: "amount", sortDirection: DESC }
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        label
        amount
      }
    }
  }
`;

//
//// Details Tables
//
export const ACCOUNTS_DETAIL_SERIES = gql`
  query accountDetailsSeries(
    $clientID: String!
    $globalFilter: GlobalFilterInput!
    $pageable: PageableInput!
    $search: String
    $tableFilter: [RangeFilter]
  ) {
    accountDetailsSeries(
      client: $clientID
      globalFilter: $globalFilter
      pageable: $pageable
      search: $search
      tableFilter: $tableFilter
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        name
        sales
        salesDelta
        units
        unitsDelta
        pod
        items
        storesSelling
        potentialStores
        voids
        opportunityGap
      }
    }
  }
`;

export const STORES_DETAIL_SERIES = gql`
  query storeDetailsSeries(
    $clientID: String!
    $globalFilter: GlobalFilterInput!
    $pageable: PageableInput!
    $search: String
    $tableFilter: [RangeFilter]
  ) {
    storeDetailsSeries(
      client: $clientID
      globalFilter: $globalFilter
      pageable: $pageable
      search: $search
      tableFilter: $tableFilter
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        name
        sales
        salesDelta
        units
        unitsDelta
        items
        voids
        topOpportunity
        storeTag
      }
    }
  }
`;

export const FETCH_GROUPS_LIST = gql`
  query fetchFilterGroups($clientID: String!, $context: String, $search: String, $brand: String) {
    fetchFilterGroups(client: $clientID, context: $context, search: $search, brand: $brand) {
      id
      context
      name
      data {
        accounts
        items
        stores
        states
      }
      created
      updated
    }
  }
`;

export const STORES_GROUPS_DETAIL_SERIES = gql`
  query storeGroupDetail($clientID: String!, $globalFilter: GlobalFilterInput!) {
    storeGroupDetail(client: $clientID, globalFilter: $globalFilter) {
      stores
      sales
      salesDelta
      units
      unitsDelta
      pod
      items
      storesSelling
      potentialStores
      voids
      opportunityGap
    }
  }
`;

export const ITEMS_DETAIL_SERIES = gql`
  query itemsDetailsSeries(
    $clientID: String!
    $globalFilter: GlobalFilterInput!
    $pageable: PageableInput!
    $search: String
    $tableFilter: [RangeFilter]
  ) {
    itemsDetailsSeries(
      client: $clientID
      globalFilter: $globalFilter
      pageable: $pageable
      search: $search
      tableFilter: $tableFilter
    ) {
      page {
        totalItems
        totalPages
      }
      data {
        name
        upc
        sales
        salesDelta
        units
        unitsDelta
        arp
        pod
        podDelta
        unitsSsw
      }
    }
  }
`;

export const ITEMS_GROUPS_DETAIL_SERIES = gql`
  query itemGroupDetail($clientID: String!, $globalFilter: GlobalFilterInput!) {
    itemGroupDetail(client: $clientID, globalFilter: $globalFilter) {
      upcCount
      sales
      salesDelta
      units
      unitsDelta
      arp
      pod
      podDelta
    }
  }
`;

export const BRANDS_DETAIL_SERIES = gql`
  query brandsDetailsSeries($clientID: String!, $globalFilter: PortfolioInput!) {
    brandResumeSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
      page {
        totalItems
        totalPages
      }
      data {
        clientId
        name
        sales
        salesDelta
        units
        unitsDelta
        pod
        podGains
        podLosses
        storesSelling
        voids
        opportunityGap
      }
    }
  }
`;

//
//// Charts
//

// Trend
export const SALES_TREND = gql`
  query salesTrend($clientID: String!, $globalFilter: GlobalFilterInput!) {
    salesTrendSeries(client: $clientID, globalFilter: $globalFilter) {
      week
      amount
    }
  }
`;

export const SALES_TREND_PORTFOLIO = gql`
  query salesTrendSeriesPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    salesTrendSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
      week
      amount
    }
  }
`;

export const LOCATIONS_TREND = gql`
  query locationsTrend($clientID: String!, $globalFilter: GlobalFilterInput!) {
    locationsTrendSeries(client: $clientID, globalFilter: $globalFilter) {
      week
      amount
    }
  }
`;

export const LOCATIONS_TREND_PORTFOLIO = gql`
  query locationsTrendPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    locationsTrendSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
      week
      amount
    }
  }
`;

export const UNITS_TREND = gql`
  query unitsTrend($clientID: String!, $globalFilter: GlobalFilterInput!) {
    unitsTrendSeries(client: $clientID, globalFilter: $globalFilter) {
      week
      amount
    }
  }
`;

export const UNITS_TREND_PORTFOLIO = gql`
  query unitsTrendPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    unitsTrendSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
      week
      amount
    }
  }
`;

// Share
export const ACCOUNT_SALES_SHARE = gql`
  query accountSalesShare($clientID: String!, $globalFilter: GlobalFilterInput!) {
    accountSalesShareSeries(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const ACCOUNT_SALES_SHARE_PORTFOLIO = gql`
  query accountSalesSharePortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    accountSalesShareSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const ACCOUNT_UNITS_SHARE = gql`
  query accountUnitsShare($clientID: String!, $globalFilter: GlobalFilterInput!) {
    accountUnitsShareSeries(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const ACCOUNT_UNITS_SHARE_PORTFOLIO = gql`
  query accountUnitsSharePortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    accountUnitsShareSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const ITEM_SALE_SHARE = gql`
  query itemsSalesShare($clientID: String!, $globalFilter: GlobalFilterInput!) {
    itemsSalesShareSeries(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const ITEM_SALE_SHARE_PORTFOLIO = gql`
  query itemsSalesSharePortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    itemsSalesShareSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const ITEM_UNIT_SHARE = gql`
  query itemsUnitsShare($clientID: String!, $globalFilter: GlobalFilterInput!) {
    itemsUnitsShareSeries(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const ITEM_UNIT_SHARE_PORTFOLIO = gql`
  query itemsUnitsSharePortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    itemsUnitsShareSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const OPPORTUNITY_SALES_SHARE = gql`
  query opportunitySalesSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
    opportunitySalesSeries(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const OPPORTUNITY_VOIDS_SHARE = gql`
  query opportunityVoidsSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
    opportunityVoidsSeries(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

// Distribution
export const DISTRIBUTION_GAINS_SERIES = gql`
  query distributionGainsSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
    distributionGainsSeries(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const DISTRIBUTION_GAINS_SERIES_PORTFOLIO = gql`
  query distributionGainsSeriesPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    distributionGainsSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const DISTRIBUTION_LOSSES_SERIES = gql`
  query distributionLossesSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
    distributionLossesSeries(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

export const DISTRIBUTION_LOSSES_SERIES_PORTFOLIO = gql`
  query distributionLossesSeriesPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
    distributionLossesSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
      label
      amount
    }
  }
`;

//
//// Create Group Modal
//

export const CREATE_GROUP = gql`
  mutation createFilterGroup($clientID: String!, $input: CreateFilterGroupInput!) {
    createFilterGroup(client: $clientID, input: $input) {
      id
    }
  }
`;

export const UPDATE_GROUP = gql`
  mutation updateFilterGroup($id: ID!, $clientID: String!, $input: CreateFilterGroupInput!) {
    updateFilterGroup(id: $id, client: $clientID, input: $input) {
      id
      context
      name
      data {
        accounts
        items
        stores
        states
      }
    }
  }
`;

export const VOIDS_ACCOUNTS_DETAILS_SERIES = gql`
  query voidAccountsDetailsSeries(
    $clientID: String!
    $globalFilter: GlobalFilterInput!
    $pageable: PageableInput!
  ) {
    voidAccountsDetailsSeries(client: $clientID, globalFilter: $globalFilter, pageable: $pageable) {
      page {
        totalItems
        totalPages
      }
      data {
        rank
        name
        sales
        voids
        items {
          voids
          upc
          description
          distributionState
          sales
          recentSaleDate
        }
      }
      itemHeaders {
        voids
        upc
        description
        sales
        recentSaleDate
      }
    }
  }
`;

export const VOIDS_STORES_DETAILS_SERIES = gql`
  query voidStoresDetailsSeries(
    $clientID: String!
    $globalFilter: GlobalFilterInput!
    $pageable: PageableInput!
  ) {
    voidStoresDetailsSeries(client: $clientID, globalFilter: $globalFilter, pageable: $pageable) {
      page {
        totalItems
        totalPages
      }
      data {
        name
        sales
        voids
        storeTag
        items {
          voids
          upc
          description
          distributionState
          sales
          recentSaleDate
        }
      }
      itemHeaders {
        voids
        upc
        description
        sales
        recentSaleDate
      }
    }
  }
`;

export const VOIDS_ITEMS_DETAILS_SERIES = gql`
  query voidItemsDetailsSeries(
    $clientID: String!
    $globalFilter: GlobalFilterInput!
    $pageable: PageableInput!
  ) {
    voidItemsDetailsSeries(client: $clientID, globalFilter: $globalFilter, pageable: $pageable) {
      page {
        totalItems
        totalPages
      }
      data {
        description
        upc
        sales
        recentSaleDate
        voids
        distributionState
      }
    }
  }
`;

export const GET_ACCOUNT_PANEL = gql`
  query accountPanel($clientID: String!, $globalFilter: GlobalFilterInput!) {
    accountPanel(client: $clientID, globalFilter: $globalFilter) {
      rank
      sales
      share
    }
  }
`;

export const GET_STORE_PANEL = gql`
  query storePanel($clientID: String!, $globalFilter: GlobalFilterInput!) {
    storePanel(client: $clientID, globalFilter: $globalFilter) {
      rank
      sales
      share
    }
  }
`;

export const GET_ITEM_PANEL = gql`
  query itemPanel($clientID: String!, $globalFilter: GlobalFilterInput!) {
    itemPanel(client: $clientID, globalFilter: $globalFilter) {
      rank
      sales
      share
      storeSalesPct
    }
  }
`;

//
////  PRODUCTS API
//

export const LIST_ACCOUNTS = gql`
  query listAccounts(
    $clientID: String!
    $accounts: [String] = null
    $stores: [String] = null
    $products: [String] = null
    $states: [String] = null
    $pageable: PageableInput!
    $weeks: Int = null
    $brand: String = ""
  ) {
    accounts(
      client: $clientID
      accounts: $accounts
      stores: $stores
      products: $products
      states: $states
      pageable: $pageable
      weeks: $weeks
      brand: $brand
    ) {
      data {
        name
      }
      page {
        currentPage
        totalItems
      }
    }
  }
`;

export const LIST_PRODUCTS = gql`
  query listProducts(
    $clientID: String!
    $accounts: [String] = null
    $products: [String] = null
    $stores: [String] = null
    $states: [String] = null
    $pageable: PageableInput!
    $weeks: Int = null
    $brand: String = ""
  ) {
    products(
      client: $clientID
      accounts: $accounts
      products: $products
      states: $states
      stores: $stores
      pageable: $pageable
      weeks: $weeks
      brand: $brand
    ) {
      data {
        __typename
        name
        upc
      }
      page {
        currentPage
        totalItems
      }
    }
  }
`;

export const GET_PRODUCT_FROM_CACHE_FRAGMENT = gql`
  fragment product on HeliosProduct {
    upc
    name
  }
`;

export const GET_PRODUCTS_BY_ID = gql`
  query GetProductsById($clientId: String!, $ids: [ID], $brand: String) {
    batchListProducts(client: $clientId, ids: $ids, brand: $brand) {
      items {
        id
        description
        upc {
          value
          type
        }
      }
    }
  }
`;

export const LIST_STATES = gql`
  query listStates(
    $clientID: String!
    $accounts: [String] = null
    $products: [String] = null
    $states: [String] = null
    $stores: [String] = null
    $pageable: PageableInput!
    $weeks: Int = null
    $brand: String = ""
  ) {
    states(
      client: $clientID
      accounts: $accounts
      products: $products
      states: $states
      stores: $stores
      pageable: $pageable
      weeks: $weeks
      brand: $brand
    ) {
      data {
        code
      }
      page {
        currentPage
        totalItems
      }
    }
  }
`;

export const LIST_STORES = gql`
  query listStores(
    $clientID: String!
    $accounts: [String] = null
    $products: [String] = null
    $states: [String] = null
    $stores: [String] = null
    $pageable: PageableInput!
    $weeks: Int = null
    $brand: String = ""
  ) {
    stores(
      client: $clientID
      accounts: $accounts
      products: $products
      states: $states
      stores: $stores
      pageable: $pageable
      weeks: $weeks
      brand: $brand
    ) {
      data {
        __typename
        address
        city
        name
        nielsenTag
        postalCode
        spinsTag
        state
        streetNumber
      }
      page {
        currentPage
        totalItems
      }
    }
  }
`;

export const GET_STORE_FROM_CACHE_FRAGMENT = gql`
  fragment store on Store {
    name
  }
`;

export const GET_STORES = gql`
  query getStore($clientId: String!, $spinsTag: String, $nielsenTag: String, $storeTag: String) {
    getStore(client: $clientId, spinsTag: $spinsTag, nielsenTag: $nielsenTag, storeTag: $storeTag) {
      name
      address
      city
      nielsenTag
      spinsTag
      state
      postalCode
      storeTag
    }
  }
`;

//
////  Favorites and Groups API
//

// Fetch Favorites
export const FETCH_FAVORITES = gql`
  query fetchFavorites($clientID: String!, $brandName: String) {
    fetchFavorites(client: $clientID, brand: $brandName) {
      id
      context
      name
      data {
        accounts
        items
        stores
        states
        weeks
        endWeek
        brand
      }
      url
      created
      deleted
    }
  }
`;

// POST Favorite
export const POST_FAVORITE = gql`
  mutation createFavorite($clientID: String!, $input: CreateFavoriteInput!) {
    createFavorite(client: $clientID, input: $input) {
      id
      context
      name
      data {
        accounts
        items
        stores
        states
        brand
      }
      url
      created
      deleted
    }
  }
`;

export const EXPORT_PDF_XLS = gql`
  query export(
    $template: String!
    $client: String!
    $exportType: ExportType!
    $recipients: [AWSEmail]!
    $globalFilter: GlobalFilterInput!
  ) {
    export(
      template: $template
      client: $client
      exportType: $exportType
      recipients: $recipients
      globalFilter: $globalFilter
    )
  }
`;

// List Campaigns
export const LIST_CAMPAIGNS = gql`
  query listCampaigns(
    $clientID: String!
    $status: [Status!]
    $brand: String
    $pageable: PageableInput
  ) {
    list(client: $clientID, status: $status, brand: $brand, pageable: $pageable) {
      data {
        id
        name
        objective
        startDate
        endDate
        status
        storeFilters {
          counts {
            stores
            accounts
          }
          stores
          accounts
          states
        }
        itemFilters {
          counts {
            items
          }
          items
        }
      }
    }
  }
`;

// Create campaign
export const CREATE_CAMPAIGN = gql`
  mutation createCampaign($input: CreateCampaignInput!, $filters: CampaignFilterInput!) {
    create(input: $input, filters: $filters) {
      id
      brand
      name
      objective
      startDate
      endDate
      status
      storeFilters {
        counts {
          stores
          accounts
        }
        accounts
        states
        stores
      }
      itemFilters {
        counts {
          items
        }
        items
      }
    }
  }
`;

// Update campaign
export const UPDATE_CAMPAIGN = gql`
  mutation updateCampaign($id: ID!, $input: CreateCampaignInput!, $filters: CampaignFilterInput!) {
    update(id: $id, input: $input, filters: $filters) {
      id
      name
      storeGroupName
      itemGroupName
      objective
      startDate
      endDate
      notes
      status
      storeFilters {
        counts {
          stores
          accounts
        }
        accounts
        stores
        states
      }
      itemFilters {
        counts {
          items
        }
        items
      }
    }
  }
`;

// Get campaign
export const GET_CAMPAIGN = gql`
  query getCampaign($id: ID!) {
    retrieve(id: $id) {
      id
      name
      storeGroupName
      itemGroupName
      objective
      startDate
      endDate
      notes
      storeFilters {
        accounts
        states
        stores
      }
      itemFilters {
        items
      }
    }
  }
`;

// Archive campaign
export const ARCHIVE_CAMPAIGN = gql`
  mutation archiveCampaign($id: ID!) {
    archive(id: $id) {
      id
      name
      objective
      startDate
      endDate
      status
      storeFilters {
        counts {
          stores
          accounts
        }
        stores
        accounts
        states
      }
      itemFilters {
        counts {
          items
        }
        items
      }
    }
  }
`;

export const GET_GROUP_INFO = gql`
  query fetchFilterGroup($id: ID!) {
    fetchFilterGroup(id: $id) {
      id
      context
      name
      data {
        accounts
        items
        stores
        states
      }
    }
  }
`;

export const GET_CLIENT_CATEGORY = gql`
  query getClientCategory($client: String!) {
    getClientCategory(client: $client) {
      category
    }
  }
`;

export const GET_BRAND_LIST_BY_CLIENT = gql`
  query getBrandListByClient(
    $clientID: String!
    $globalFilter: PortfolioInput
    $pageable: PageableInput!
  ) {
    getBrandListByClient(client: $clientID, globalFilter: $globalFilter, pageable: $pageable) {
      page {
        totalItems
        totalPages
        currentPage
      }
      data {
        client
        brand
      }
    }
  }
`;

export const BRAND_RESUME_PORTFOLIO = gql`
  query brandResumePortfolio(
    $clientID: String!
    $globalFilter: PortfolioInput!
    $pageable: PageableInput!
    $tableFilter: [RangeFilter]
  ) {
    brandResumePortfolio(
      client: $clientID
      globalFilter: $globalFilter
      pageable: $pageable
      tableFilter: $tableFilter
    ) {
      page {
        totalItems
        totalPages
        currentPage
      }
      data {
        name
        sales
        salesDelta
        units
        unitsDelta
        pod
        podGains
        podLosses
        storesSelling
        voids
        opportunityGap
      }
    }
  }
`;

export const GET_WHITELISTED_CLIENTS = gql`
  query whiteListedClients {
    whiteListedClients
  }
`;
